import React from "react";
import { ReactComponent as ShoppingIcon } from "components/cart/cartIcon/shopping-bag.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  cartItemsCount,
  selectCartHidden,
  toggleCart,
} from "features/cart/cartSlice";
import styled from "styled-components";
import CartDropdown from "./cartDropdown/CartDropdown";

export default function Cart({ onCloseMenu }) {
  // const totalAmount = useSelector((state) => state.cart.cartItems);
  const totalAmount = useSelector(cartItemsCount);
  const dispatch = useDispatch();

  const handleCartToggle = () => {
    dispatch(toggleCart());
    onCloseMenu();
  };

  return (
    <>
      <CartIconContainer onClick={handleCartToggle}>
        <CartIcon />
        <ItemCount>
          {/* {totalAmount.reduce((amount, { quantity }) => amount + quantity, 0)} */}
          {totalAmount}
        </ItemCount>
      </CartIconContainer>
    </>
  );
}

const CartIconContainer = styled.div.attrs((props) => ({
  className: "relative cursor-pointer flex justify-center items-center",
}))``;

const CartIcon = styled(ShoppingIcon).attrs((props) => ({
  className: "w-6 h-6",
}))``;

const ItemCount = styled.span.attrs((props) => ({
  className: "absolute text-xs top-1/3",
}))``;
